export default [
    {
        "code": "aa",
        "name": "Afar",
        "native": "Afaraf"
    },
    {
        "code": "ab",
        "name": "Abkhaz",
        "native": "аҧсуа бызшәа, аҧсшәа"
    },
    {
        "code": "ae",
        "name": "Avestan",
        "native": "avesta"
    },
    {
        "code": "af",
        "name": "Afrikaans",
        "native": "Afrikaans"
    },
    {
        "code": "ak",
        "name": "Akan",
        "native": "Akan"
    },
    {
        "code": "am",
        "name": "Amharic",
        "native": "አማርኛ"
    },
    {
        "code": "an",
        "name": "Aragonese",
        "native": "aragonés"
    },
    {
        "code": "ar",
        "name": "Arabic",
        "native": "العربية"
    },
    {
        "code": "as",
        "name": "Assamese",
        "native": "অসমীয়া"
    },
    {
        "code": "av",
        "name": "Avaric",
        "native": "авар мацӀ, магӀарул мацӀ"
    },
    {
        "code": "ay",
        "name": "Aymara",
        "native": "aymar aru"
    },
    {
        "code": "az",
        "name": "Azerbaijani",
        "native": "azərbaycan dili"
    },
    {
        "code": "ba",
        "name": "Bashkir",
        "native": "башҡорт теле"
    },
    {
        "code": "be",
        "name": "Belarusian",
        "native": "беларуская мова"
    },
    {
        "code": "bg",
        "name": "Bulgarian",
        "native": "български език"
    },
    {
        "code": "bh",
        "name": "Bihari",
        "native": "भोजपुरी"
    },
    {
        "code": "bi",
        "name": "Bislama",
        "native": "Bislama"
    },
    {
        "code": "bm",
        "name": "Bambara",
        "native": "bamanankan"
    },
    {
        "code": "bn",
        "name": "Bengali, Bangla",
        "native": "বাংলা"
    },
    {
        "code": "bo",
        "name": "Tibetan Standard, Tibetan, Central",
        "native": "བོད་ཡིག"
    },
    {
        "code": "br",
        "name": "Breton",
        "native": "brezhoneg"
    },
    {
        "code": "bs",
        "name": "Bosnian",
        "native": "bosanski jezik"
    },
    {
        "code": "ca",
        "name": "Catalan",
        "native": "català"
    },
    {
        "code": "ce",
        "name": "Chechen",
        "native": "нохчийн мотт"
    },
    {
        "code": "ch",
        "name": "Chamorro",
        "native": "Chamoru"
    },
    {
        "code": "co",
        "name": "Corsican",
        "native": "corsu, lingua corsa"
    },
    {
        "code": "cr",
        "name": "Cree",
        "native": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    {
        "code": "cs",
        "name": "Czech",
        "native": "čeština, český jazyk"
    },
    {
        "code": "cu",
        "name": "Old Church Slavonic, Church Slavonic, Old Bulgarian",
        "native": "ѩзыкъ словѣньскъ"
    },
    {
        "code": "cv",
        "name": "Chuvash",
        "native": "чӑваш чӗлхи"
    },
    {
        "code": "cy",
        "name": "Welsh",
        "native": "Cymraeg"
    },
    {
        "code": "da",
        "name": "Danish",
        "native": "dansk"
    },
    {
        "code": "de",
        "name": "German",
        "native": "Deutsch"
    },
    {
        "code": "dv",
        "name": "Divehi, Dhivehi, Maldivian",
        "native": "ދިވެހި"
    },
    {
        "code": "dz",
        "name": "Dzongkha",
        "native": "རྫོང་ཁ"
    },
    {
        "code": "ee",
        "name": "Ewe",
        "native": "Eʋegbe"
    },
    {
        "code": "el",
        "name": "Greek (modern)",
        "native": "ελληνικά"
    },
    {
        "code": "en",
        "name": "English",
        "native": "English"
    },
    {
        "code": "eo",
        "name": "Esperanto",
        "native": "Esperanto"
    },
    {
        "code": "es",
        "name": "Spanish",
        "native": "Español"
    },
    {
        "code": "et",
        "name": "Estonian",
        "native": "eesti, eesti keel"
    },
    {
        "code": "eu",
        "name": "Basque",
        "native": "euskara, euskera"
    },
    {
        "code": "fa",
        "name": "Persian (Farsi)",
        "native": "فارسی"
    },
    {
        "code": "ff",
        "name": "Fula, Fulah, Pulaar, Pular",
        "native": "Fulfulde, Pulaar, Pular"
    },
    {
        "code": "fi",
        "name": "Finnish",
        "native": "suomi, suomen kieli"
    },
    {
        "code": "fj",
        "name": "Fijian",
        "native": "vosa Vakaviti"
    },
    {
        "code": "fo",
        "name": "Faroese",
        "native": "føroyskt"
    },
    {
        "code": "fr",
        "name": "French",
        "native": "français, langue française"
    },
    {
        "code": "fy",
        "name": "Western Frisian",
        "native": "Frysk"
    },
    {
        "code": "ga",
        "name": "Irish",
        "native": "Gaeilge"
    },
    {
        "code": "gd",
        "name": "Scottish Gaelic, Gaelic",
        "native": "Gàidhlig"
    },
    {
        "code": "gl",
        "name": "Galician",
        "native": "galego"
    },
    {
        "code": "gn",
        "name": "Guaraní",
        "native": "Avañe'ẽ"
    },
    {
        "code": "gu",
        "name": "Gujarati",
        "native": "ગુજરાતી"
    },
    {
        "code": "gv",
        "name": "Manx",
        "native": "Gaelg, Gailck"
    },
    {
        "code": "ha",
        "name": "Hausa",
        "native": "(Hausa) هَوُسَ"
    },
    {
        "code": "he",
        "name": "Hebrew (modern)",
        "native": "עברית"
    },
    {
        "code": "hi",
        "name": "Hindi",
        "native": "हिन्दी, हिंदी"
    },
    {
        "code": "ho",
        "name": "Hiri Motu",
        "native": "Hiri Motu"
    },
    {
        "code": "hr",
        "name": "Croatian",
        "native": "hrvatski jezik"
    },
    {
        "code": "ht",
        "name": "Haitian, Haitian Creole",
        "native": "Kreyòl ayisyen"
    },
    {
        "code": "hu",
        "name": "Hungarian",
        "native": "magyar"
    },
    {
        "code": "hy",
        "name": "Armenian",
        "native": "Հայերեն"
    },
    {
        "code": "hz",
        "name": "Herero",
        "native": "Otjiherero"
    },
    {
        "code": "ia",
        "name": "Interlingua",
        "native": "Interlingua"
    },
    {
        "code": "id",
        "name": "Indonesian",
        "native": "Bahasa Indonesia"
    },
    {
        "code": "ie",
        "name": "Interlingue",
        "native": "Originally called Occidental; then Interlingue after WWII"
    },
    {
        "code": "ig",
        "name": "Igbo",
        "native": "Asụsụ Igbo"
    },
    {
        "code": "ii",
        "name": "Nuosu",
        "native": "ꆈꌠ꒿ Nuosuhxop"
    },
    {
        "code": "ik",
        "name": "Inupiaq",
        "native": "Iñupiaq, Iñupiatun"
    },
    {
        "code": "io",
        "name": "Ido",
        "native": "Ido"
    },
    {
        "code": "is",
        "name": "Icelandic",
        "native": "Íslenska"
    },
    {
        "code": "it",
        "name": "Italian",
        "native": "Italiano"
    },
    {
        "code": "iu",
        "name": "Inuktitut",
        "native": "ᐃᓄᒃᑎᑐᑦ"
    },
    {
        "code": "ja",
        "name": "Japanese",
        "native": "日本語 (にほんご)"
    },
    {
        "code": "jv",
        "name": "Javanese",
        "native": "ꦧꦱꦗꦮ, Basa Jawa"
    },
    {
        "code": "ka",
        "name": "Georgian",
        "native": "ქართული"
    },
    {
        "code": "kg",
        "name": "Kongo",
        "native": "Kikongo"
    },
    {
        "code": "ki",
        "name": "Kikuyu, Gikuyu",
        "native": "Gĩkũyũ"
    },
    {
        "code": "kj",
        "name": "Kwanyama, Kuanyama",
        "native": "Kuanyama"
    },
    {
        "code": "kk",
        "name": "Kazakh",
        "native": "қазақ тілі"
    },
    {
        "code": "kl",
        "name": "Kalaallisut, Greenlandic",
        "native": "kalaallisut, kalaallit oqaasii"
    },
    {
        "code": "km",
        "name": "Khmer",
        "native": "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ"
    },
    {
        "code": "kn",
        "name": "Kannada",
        "native": "ಕನ್ನಡ"
    },
    {
        "code": "ko",
        "name": "Korean",
        "native": "한국어"
    },
    {
        "code": "kr",
        "name": "Kanuri",
        "native": "Kanuri"
    },
    {
        "code": "ks",
        "name": "Kashmiri",
        "native": "कश्मीरी, كشميري‎"
    },
    {
        "code": "ku",
        "name": "Kurdish",
        "native": "Kurdî, كوردی‎"
    },
    {
        "code": "kv",
        "name": "Komi",
        "native": "коми кыв"
    },
    {
        "code": "kw",
        "name": "Cornish",
        "native": "Kernewek"
    },
    {
        "code": "ky",
        "name": "Kyrgyz",
        "native": "Кыргызча, Кыргыз тили"
    },
    {
        "code": "la",
        "name": "Latin",
        "native": "latine, lingua latina"
    },
    {
        "code": "lb",
        "name": "Luxembourgish, Letzeburgesch",
        "native": "Lëtzebuergesch"
    },
    {
        "code": "lg",
        "name": "Ganda",
        "native": "Luganda"
    },
    {
        "code": "li",
        "name": "Limburgish, Limburgan, Limburger",
        "native": "Limburgs"
    },
    {
        "code": "ln",
        "name": "Lingala",
        "native": "Lingála"
    },
    {
        "code": "lo",
        "name": "Lao",
        "native": "ພາສາລາວ"
    },
    {
        "code": "lt",
        "name": "Lithuanian",
        "native": "lietuvių kalba"
    },
    {
        "code": "lu",
        "name": "Luba-Katanga",
        "native": "Tshiluba"
    },
    {
        "code": "lv",
        "name": "Latvian",
        "native": "latviešu valoda"
    },
    {
        "code": "mg",
        "name": "Malagasy",
        "native": "fiteny malagasy"
    },
    {
        "code": "mh",
        "name": "Marshallese",
        "native": "Kajin M̧ajeļ"
    },
    {
        "code": "mi",
        "name": "Māori",
        "native": "te reo Māori"
    },
    {
        "code": "mk",
        "name": "Macedonian",
        "native": "македонски јазик"
    },
    {
        "code": "ml",
        "name": "Malayalam",
        "native": "മലയാളം"
    },
    {
        "code": "mn",
        "name": "Mongolian",
        "native": "Монгол хэл"
    },
    {
        "code": "mr",
        "name": "Marathi (Marāṭhī)",
        "native": "मराठी"
    },
    {
        "code": "ms",
        "name": "Malay",
        "native": "bahasa Melayu, بهاس ملايو‎"
    },
    {
        "code": "mt",
        "name": "Maltese",
        "native": "Malti"
    },
    {
        "code": "my",
        "name": "Burmese",
        "native": "ဗမာစာ"
    },
    {
        "code": "na",
        "name": "Nauruan",
        "native": "Dorerin Naoero"
    },
    {
        "code": "nb",
        "name": "Norwegian Bokmål",
        "native": "Norsk bokmål"
    },
    {
        "code": "nd",
        "name": "Northern Ndebele",
        "native": "isiNdebele"
    },
    {
        "code": "ne",
        "name": "Nepali",
        "native": "नेपाली"
    },
    {
        "code": "ng",
        "name": "Ndonga",
        "native": "Owambo"
    },
    {
        "code": "nl",
        "name": "Dutch",
        "native": "Nederlands, Vlaams"
    },
    {
        "code": "nn",
        "name": "Norwegian Nynorsk",
        "native": "Norsk nynorsk"
    },
    {
        "code": "no",
        "name": "Norwegian",
        "native": "Norsk"
    },
    {
        "code": "nr",
        "name": "Southern Ndebele",
        "native": "isiNdebele"
    },
    {
        "code": "nv",
        "name": "Navajo, Navaho",
        "native": "Diné bizaad"
    },
    {
        "code": "ny",
        "name": "Chichewa, Chewa, Nyanja",
        "native": "chiCheŵa, chinyanja"
    },
    {
        "code": "oc",
        "name": "Occitan",
        "native": "occitan, lenga d'òc"
    },
    {
        "code": "oj",
        "name": "Ojibwe, Ojibwa",
        "native": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    {
        "code": "om",
        "name": "Oromo",
        "native": "Afaan Oromoo"
    },
    {
        "code": "or",
        "name": "Oriya",
        "native": "ଓଡ଼ିଆ"
    },
    {
        "code": "os",
        "name": "Ossetian, Ossetic",
        "native": "ирон æвзаг"
    },
    {
        "code": "pa",
        "name": "(Eastern) Punjabi",
        "native": "ਪੰਜਾਬੀ"
    },
    {
        "code": "pi",
        "name": "Pāli",
        "native": "पाऴि"
    },
    {
        "code": "pl",
        "name": "Polish",
        "native": "język polski, polszczyzna"
    },
    {
        "code": "ps",
        "name": "Pashto, Pushto",
        "native": "پښتو"
    },
    {
        "code": "pt",
        "name": "Portuguese",
        "native": "Português"
    },
    {
        "code": "qu",
        "name": "Quechua",
        "native": "Runa Simi, Kichwa"
    },
    {
        "code": "rm",
        "name": "Romansh",
        "native": "rumantsch grischun"
    },
    {
        "code": "rn",
        "name": "Kirundi",
        "native": "Ikirundi"
    },
    {
        "code": "ro",
        "name": "Romanian",
        "native": "Română"
    },
    {
        "code": "ru",
        "name": "Russian",
        "native": "Русский"
    },
    {
        "code": "rw",
        "name": "Kinyarwanda",
        "native": "Ikinyarwanda"
    },
    {
        "code": "sa",
        "name": "Sanskrit (Saṁskṛta)",
        "native": "संस्कृतम्"
    },
    {
        "code": "sc",
        "name": "Sardinian",
        "native": "sardu"
    },
    {
        "code": "sd",
        "name": "Sindhi",
        "native": "सिन्धी, سنڌي، سندھی‎"
    },
    {
        "code": "se",
        "name": "Northern Sami",
        "native": "Davvisámegiella"
    },
    {
        "code": "sg",
        "name": "Sango",
        "native": "yângâ tî sängö"
    },
    {
        "code": "si",
        "name": "Sinhalese, Sinhala",
        "native": "සිංහල"
    },
    {
        "code": "sk",
        "name": "Slovak",
        "native": "slovenčina, slovenský jazyk"
    },
    {
        "code": "sl",
        "name": "Slovene",
        "native": "slovenski jezik, slovenščina"
    },
    {
        "code": "sm",
        "name": "Samoan",
        "native": "gagana fa'a Samoa"
    },
    {
        "code": "sn",
        "name": "Shona",
        "native": "chiShona"
    },
    {
        "code": "so",
        "name": "Somali",
        "native": "Soomaaliga, af Soomaali"
    },
    {
        "code": "sq",
        "name": "Albanian",
        "native": "Shqip"
    },
    {
        "code": "sr",
        "name": "Serbian",
        "native": "српски језик"
    },
    {
        "code": "ss",
        "name": "Swati",
        "native": "SiSwati"
    },
    {
        "code": "st",
        "name": "Southern Sotho",
        "native": "Sesotho"
    },
    {
        "code": "su",
        "name": "Sundanese",
        "native": "Basa Sunda"
    },
    {
        "code": "sv",
        "name": "Swedish",
        "native": "svenska"
    },
    {
        "code": "sw",
        "name": "Swahili",
        "native": "Kiswahili"
    },
    {
        "code": "ta",
        "name": "Tamil",
        "native": "தமிழ்"
    },
    {
        "code": "te",
        "name": "Telugu",
        "native": "తెలుగు"
    },
    {
        "code": "tg",
        "name": "Tajik",
        "native": "тоҷикӣ, toçikī, تاجیکی‎"
    },
    {
        "code": "th",
        "name": "Thai",
        "native": "ไทย"
    },
    {
        "code": "ti",
        "name": "Tigrinya",
        "native": "ትግርኛ"
    },
    {
        "code": "tk",
        "name": "Turkmen",
        "native": "Türkmen, Түркмен"
    },
    {
        "code": "tl",
        "name": "Tagalog / Filipino",
        "native": "Wikang Tagalog"
    },
    {
        "code": "tn",
        "name": "Tswana",
        "native": "Setswana"
    },
    {
        "code": "to",
        "name": "Tonga (Tonga Islands)",
        "native": "faka Tonga"
    },
    {
        "code": "tr",
        "name": "Turkish",
        "native": "Türkçe"
    },
    {
        "code": "ts",
        "name": "Tsonga",
        "native": "Xitsonga"
    },
    {
        "code": "tt",
        "name": "Tatar",
        "native": "татар теле, tatar tele"
    },
    {
        "code": "tw",
        "name": "Twi",
        "native": "Twi"
    },
    {
        "code": "ty",
        "name": "Tahitian",
        "native": "Reo Tahiti"
    },
    {
        "code": "ug",
        "name": "Uyghur",
        "native": "ئۇيغۇرچە‎, Uyghurche"
    },
    {
        "code": "uk",
        "name": "Ukrainian",
        "native": "Українська"
    },
    {
        "code": "ur",
        "name": "Urdu",
        "native": "اردو"
    },
    {
        "code": "uz",
        "name": "Uzbek",
        "native": "Oʻzbek, Ўзбек, أۇزبېك‎"
    },
    {
        "code": "ve",
        "name": "Venda",
        "native": "Tshivenḓa"
    },
    {
        "code": "vi",
        "name": "Vietnamese",
        "native": "Tiếng Việt"
    },
    {
        "code": "vo",
        "name": "Volapük",
        "native": "Volapük"
    },
    {
        "code": "wa",
        "name": "Walloon",
        "native": "walon"
    },
    {
        "code": "wo",
        "name": "Wolof",
        "native": "Wollof"
    },
    {
        "code": "xh",
        "name": "Xhosa",
        "native": "isiXhosa"
    },
    {
        "code": "yi",
        "name": "Yiddish",
        "native": "ייִדיש"
    },
    {
        "code": "yo",
        "name": "Yoruba",
        "native": "Yorùbá"
    },
    {
        "code": "za",
        "name": "Zhuang, Chuang",
        "native": "Saɯ cueŋƅ, Saw cuengh"
    },
    {
        "code": "zh",
        "name": "Chinese",
        "native": "中文 (Zhōngwén), 汉语, 漢語"
    },
    {
        "code": "zu",
        "name": "Zulu",
        "native": "isiZulu"
    }
];